import React, { useState, Fragment, useEffect } from "react";
import { getTitleTable, getDataSource, columnsTable, genaratePaginateFilterSort, checkUndefine, formatValidation } from "../../../../../helpers/functions";
import { FilterDropdown, ListComponent, StatusComponent } from "../../../common/component/Index";
import { useTranslation } from "react-i18next";
import { Icon, Menu , Input, Button, Tooltip} from "antd";
import { SupplierProduct } from "../../../../../models/Supplier";
import * as ANT from "antd";
import AntSelect, { AntOption } from '../../../common/component/AntSelect';
import Dropdown from "../../../common/component/Dropdown";
import Modal from "../../../common/component/Modal";
import { Link } from 'react-router-dom';
import * as Func from '../../../../../helpers/functions';
import * as HMS from "../../../common/component/Index";
import EllipsisText from '../../../common/component/EllipsisText';
import { PATHS, SUPPLIER } from '../../../../../constants/Define';
import { toArray, find } from 'lodash';

import './ProductList.less'

const ListCols = ['supplierName', 'name', 'typeTitle', 'supplierTypes', 'description', 'productCode', 'cost', 'transactionCode', 'isActive'];

const ModelFields = Object.getOwnPropertyNames(new SupplierProduct());
const ProductList = ({ ...props }) => {
    const { supplierState, getSupplierProducts, deleteSupplierProduct, getSupplierAll, fetchSupplierLst, permissionActions } = props;
    const { isFetchingProduct, supplierProducts, supplierAll, pageSize, pageIndex, totalCount, totalPage } = supplierState;
    const { t } = useTranslation();
    const [titleItemTable, setTitleItemTable] = useState(getTitleTable(ListCols, ['action'], ['supplierTypes']),);
    const [componentTable, setComponentTable] = useState(
        {
            supplierName: {
                key: 'supplierName',
                render: (text, record) => text,
                fixed: 'left',
            },
            name: {
                key: 'searchTerm',
                fixed: 'left',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
                render: (text, record)=>
                    <EllipsisText title={record.name} content={record.name} contentMaxWidth={120} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />
            },
            // supplierTypes: {
            //     key: 'supplierTypes',
            //     render: (supplierTypes, record) => supplierTypes ? 
            //     supplierTypes.map(item => t(`item.supplier.product.type.${find(toArray(SUPPLIER.PRODUCT.TYPE), type => type.id === item)?.key}`)).join(', ') : '',
            //     filters: toArray(SUPPLIER.PRODUCT.TYPE).map(item => {
            //         return {
            //             ...item,
            //             value: item.id,
            //             text: t(`item.supplier.product.type.${item.key}`)
            //         }
            //     }),
            //     filterMultiple: false,
            // },
            typeTitle: {
                key: 'categoryName',
                render: (type, record) => 
                    <EllipsisText title={record.categoryName || ''} content={record.categoryName || ''} contentMaxWidth={280} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            description: {
                key: 'description',
                width: 200,
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={280} overlayClassName={'max-width-500'} overlayComponent={Tooltip} />,
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <FilterDropdown
                        setSelectedKeys={ setSelectedKeys }
                        selectedKeys={ selectedKeys }
                        confirm={ confirm }
                        clearFilters={ clearFilters }
                    >
                    </FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={ { color: filtered ? '#1890ff' : undefined } }/>
                ),
            },
            transactionCode: {
                key: 'transactionCode',
                render: (text, record) => text
            },
            cost: {
                key: 'cost',
                render: (amount, record) => amount && Func.formatMoney(amount)
            },
            // sellCost: {
            //     key: 'sellCost',
            //     render: (amount, record) => amount && Func.formatMoney(amount)
            // },
            isActive: {
                key: 'isActive',
                render: (text, record) => (
                    <StatusComponent color={ text ? 'green' : 'red' } label={ text ? t('item.supplier.product.isActive') : t('item.supplier.product.block') }/>
                ),
                filters: [
                    { value: true, text: t('item.supplier.product.isActive') },
                    { value: false, text: t('item.supplier.product.block') },
                ],
                filterMultiple: false,
            },
            action: {
                width: 100,
                align: 'center',
                key: 'action',
                fixed: 'right',
                render: (text, record) => renderEditComponent(record),
            }
        }
    );
    const [modelItem, setModelItem] = useState(ModelFields);
    const [dataFilter, setDataFilter] = useState({
        filters: {
            pageSize: supplierState.pageSize,
            pageIndex: supplierState.pageIndex,
        },
    })
    const [dataSearch, setDataSearch] = useState({
        supplierTypes: [],
        supplierIds: [],
    })
    useEffect(() => {
        function loadData(){
            if (fetchSupplierLst) {
                getSupplierProducts(dataFilter.filters);
                getSupplierAll();
            }
        }
        loadData();
    }, [fetchSupplierLst])

    const onColumnVisibleChange = (column, isVisibled) => {
        const currentComponentTable = componentTable;
        currentComponentTable[column.dataIndex].visible = isVisibled;
        setComponentTable(currentComponentTable);
    }

    const onTableChange = (pagination, filters, sorter) => {
        let newFilters = genaratePaginateFilterSort(pagination, filters, sorter);
        setDataFilter({ filters: newFilters });
        getSupplierProducts({ ...newFilters, ...dataSearch });
    }

    const getProductSupplierType = ()=>{
        let arrOpt = toArray(SUPPLIER.PRODUCT_SUPPLIER.TYPE);
        if(arrOpt.length > 0){
            arrOpt = arrOpt.map((item)=>{
                return{
                    ...item,
                    label: t(`item.supplier.product.${item.label}`)
                }
            })
        }
        return arrOpt;
    }

    const onChangeSelect = (fieldName, value)=>{
        setDataSearch({
            ...dataSearch,
            [fieldName]: value
        });
    }

    const onSearchSupplierProduct = () => {
        getSupplierProducts({...dataFilter.filters, ...dataSearch});
    }

    const renderEditComponent = (item)=> {
        const removeItem = () => {
            return deleteSupplierProduct && deleteSupplierProduct(item);
        }
        const onRemove = () => {
            const { confirm } = Modal;
            confirm({
                title: Func.formatValidation(t('validation.statusCode.code.7'), t(`item.supplier.product.title`)),
                content: item.name,
                okText: t(`action.remove`),
                cancelText: t(`action.cancel`),
                onOk: removeItem,
            });
        };
        return (
            <Dropdown overlay={
                <Menu className="action-menu">
                    {
                        permissionActions && permissionActions.allowUpdate &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.SUPPLIER_PRODUCT.DETAIL.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="form" className="fs20 mr-1" /> {t(`action.edit`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permissionActions && permissionActions.allowView &&
                        <Menu.Item>
                            <Link to={Func.getPathWithParams(PATHS.SUPPLIER_PRODUCT.USAGE_PLAN.path, { id: item.id })} className={`mr-2 colorPrimary`}>
                                <Icon type="eye" className="fs20 mr-1" /> {t(`action.usagePlan`)}
                            </Link>
                        </Menu.Item>
                    }

                    {
                        permissionActions && permissionActions.allowDelete &&
                        <Menu.Item onClick={onRemove}><Icon type="delete" className="fs20 mr-1" />{t(`action.remove`)}</Menu.Item>
                    }
                </Menu>
            }>
                <Icon type="more" className="fs20 cursorPointer" />
            </Dropdown>
        )
    }

    return (
        <Fragment>
            <div className="box-search-supplier-product">
                <div className="col-md-3">
                    <HMS.FormWrapperInputComponent
                        labelTitle={ t(`item.supplier.product.typeSupplier`) }
                    >
                        <AntSelect className="select-types"
                            mode="multiple"
                            showArrow
                            allowClear
                            placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.typeSupplier")).toLowerCase()) }
                            value={ dataSearch.supplierTypes }
                            onChange={ type => onChangeSelect('supplierTypes', type)}
                            style={ { width: '100%' } }
                            // filterOption={ this.props.selectFilterSearch }
                        >
                            { (getProductSupplierType() || []).map(sp => (
                                <AntOption key={ sp.id } value={ sp.value }>
                                    { sp.label }
                                </AntOption>
                            )) }
                        </AntSelect>
                    </HMS.FormWrapperInputComponent>
                </div>
                <div className="col-md-4">
                    <HMS.FormWrapperInputComponent
                        labelTitle={ t(`item.supplier.product.supplierName`) }
                    >
                        <AntSelect className="select-types"
                            mode="multiple"
                            showArrow
                            placeholder={ Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.supplier.product.supplierName")).toLowerCase()) }
                            value={ dataSearch.supplierIds }
                            onChange={ id => onChangeSelect('supplierIds', id) }
                            style={ { width: '100%' } }
                        >
                            { (supplierAll || []).map(item => (
                                <AntOption key={ item.id } value={ item.id }>
                                    { item.supplierName }
                                </AntOption>
                            )) }
                        </AntSelect>
                    </HMS.FormWrapperInputComponent>
                </div>
                <div className="col-md-3 btn-center">
                    {/* {
                        isShowBtnUpdateStatus &&
                        <Button className="mr-2" type="primary" icon="check" >{ isActive ? t('item.promotions.bulkDeactivated') : t('item.promotions.bulkActive') }</Button>
                    } */}
                     <HMS.FormWrapperInputComponent
                        labelTitle={ "" }
                    >
                        <Button type="primary" icon="search" onClick={onSearchSupplierProduct}>{ t('action.search') }</Button>
                    </HMS.FormWrapperInputComponent>
                </div>
            </div>
            
            <ListComponent
                tableKey="bundle-list"
                classChildren="p-0" classParent="m-0"
                scroll={{ x: 1300 }}
                rowKey={ (record, k) => record.id ? record.id : k }
                loading={ { spinning: isFetchingProduct, size: 'large' } }
                dataSource={ getDataSource(supplierProducts || [], modelItem) }
                columns={ columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'supplier.product'
                }) }
                onChange={ onTableChange }
                componentTableList={ {} }
                onColumnVisibleChange={ onColumnVisibleChange }
                pagination={ { total: totalCount, totalPage: totalPage, pageSize, current: pageIndex } }
            >
            </ListComponent>
        </Fragment>
    )
}

export default ProductList;
